import { FeatureFlagDetail } from 'posthog-js'

/**
 * Converts a feature flag detail to a string representation for input fields.
 * @param {FeatureFlagDetail | undefined} detail
 * @returns {string}
 */
export const flagValueToString = (detail: FeatureFlagDetail | undefined): string => {
  if (!detail) return ''
  if (!detail.enabled) return 'false'
  return detail.variant ?? 'true'
}

/**
 * Parses a raw input value from a string to its appropriate type (string or boolean).
 * @param {string} raw
 * @returns {string | boolean}
 */
export const parseInputValue = (raw: string): string | boolean => {
  if (raw === 'true') return true
  if (raw === 'false') return false
  return raw
}
